import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Tarifa } from './tarifa';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-tarifa',
  templateUrl: './tarifa.component.html'
})
export class TarifaComponent extends BaseModalContainer<Tarifa> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Tarifa>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }


  ngOnInit() {
  }

}
